import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IBaseBusinessManageRepository } from '@/coreInfrastructureModule/interfaces/IBaseBusinessManageRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

/**
 * 売り上げ先番号を取得するユースケース
 * @param customer - 売り上げ先情報
 */
export class GetCustomerNumberUseCase {
  private repository: IBaseBusinessManageRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IBaseBusinessManageRepository) {
    this.repository = repository;
  }
  /**
   * 売り上げ先番号を取得する
   * @param customerName - 売り上げ先名
   */
  async execute(customerName: string): Promise<INetworkResult<string | undefined, IError>> {
    try {
      const result = await this.repository.getCustomerNumber(customerName);
      return result;
    } catch (error) {
      console.error(error);
      return {
        status: {
          type: 'error',
          error: {
            message: '想定外のエラーが発生しました',
            statusCode: 0,
            code: '',
          },
        },
      };
    }
  }
}
